import React from "react";
import { useNavigate } from "react-router-dom";
import TopNavigation from "components/ui/TopNavigation";
import Icon from "components/AppIcon";
import GymSettings from "../gym-owner-portal/components/GymSettings";

export default function GymOwnerSettings() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <TopNavigation />
      <main>
        <div className="bg-[var(--color-card)] border-b border-[var(--color-border)] px-4 md:px-6 py-4">
          <div className="max-w-screen-2xl mx-auto">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-md bg-[var(--color-primary)]/15 flex items-center justify-center">
                <Icon name="Settings" size={15} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-lg font-bold font-[var(--font-heading)] text-[var(--color-foreground)]">Settings</h1>
                <p className="text-sm text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Gym configuration and preferences</p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-6">
          <div className="max-w-2xl space-y-4">
            <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-[var(--radius-md)] shadow-[var(--shadow-sm)] p-4 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-[var(--color-primary)]/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Building2" size={18} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-sm font-semibold font-[var(--font-heading)] text-[var(--color-foreground)]">Gym Profile & Setup</p>
                  <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Update your gym name, address, working hours, logo and social links</p>
                </div>
              </div>
              <button
                onClick={() => navigate('/gym-setup')}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold font-[var(--font-caption)] bg-[var(--color-primary)] text-white rounded-lg hover:bg-[var(--color-secondary)] transition-colors flex-shrink-0"
              >
                <Icon name="Settings" size={13} color="white" />
                Edit Setup
              </button>
            </div>
            <GymSettings />
          </div>
        </div>
      </main>
    </div>
  );
}
